import { API_BASE_URL } from '@/utils/config';

export interface LeadCaptureData {
  email: string;
  beforeImageUrl: string;
  finishId: string;
  glossLevel: string;
}

export interface LeadCaptureResponse {
  success: boolean;
}

export async function submitLeadCapture(data: LeadCaptureData): Promise<LeadCaptureResponse> {
  const response = await fetch(`${API_BASE_URL}/api/v2/lead`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Lead capture failed' }));
    throw new Error(err.error || `Lead error: ${response.status}`);
  }

  return response.json();
}
